// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2wGyd","label":"Radio_label__10XeP","checkMark":"Radio_checkMark__-fZBq","disabled":"Radio_disabled__1RqMM"};